import { IState } from '../../store';

export const selectSoprApi = (state: IState): string => state.soprApi;
